export const MAX_SIGNAL_LVL = 4;
